


































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import CenteredColumnLayout from '../CenteredColumnLayout.vue'
import ListOverlay from './components//ListOverlay.vue'
import EntityCard from './components/EntityCard.vue'
import { matchedRouteParams, customReplacer } from './includes/helpers'
import {
  EntitiesList,
  EntityCardStructure,
  EntityTypes, SelectedEntitiesInput,
} from './includes/types'

@Component({
  components: {
    ListOverlay,
    EntityCard,
    CenteredColumnLayout
  }
})
export default class SelectEntity extends Vue {

  @Prop({ type: Object, required: true }) entities!: EntitiesList

  currentStepIndex = 0

  selectMap: SelectedEntitiesInput = []

  get isLastStep() {
    return this.currentStepIndex === this.selectMap.length - 1
  }

  get selectEntityPrefix():string {
    const type = this.selectMap[this.currentStepIndex].type

    return type.toLowerCase()
  }

  get selectEntityTitle():string {
    return this.$t(`${ this.selectEntityPrefix }_title`).toString()
  }

  onSelect(id: EntityCardStructure['id']):void {
    this.selectMap[this.currentStepIndex].selectedId = id

    if (!this.isLastStep) {
      const nextStepIndex = this.currentStepIndex + 1
      const nextStep = this.selectMap[nextStepIndex]

      this.selectMap[nextStepIndex].data = this.entities[nextStep.type](id)

      this.currentStepIndex += 1
    } else {
      let newPath = this.$route.fullPath

      this.selectMap.forEach(entity => {
        if (entity.selectedId !== null) {
          const param = matchedRouteParams(this.$route)?.find(p => /[a-z]/.test(p))
          let entityTypePath = entity.type.toString();

          if (param && param === entity.type.toLowerCase()) {
            entityTypePath = entityTypePath.toString().toLowerCase()
          }

          newPath = newPath.replace(entityTypePath, entity.selectedId.toString())
        }
      })

      if (customReplacer !== null && !!customReplacer.onWizardFinish) {
        customReplacer.onWizardFinish(newPath, this.selectMap, this.$route)
      } else {
        this.$router.replace({ path: newPath })
      }
    }
  }

  handleStepBack():void {
    this.selectMap[this.currentStepIndex].selectedId = null

    this.currentStepIndex --
  }

  created(): void {
    const params = matchedRouteParams(this.$route)

    if (params !== null) {
      params.forEach(param => {
        const type = param.toUpperCase() as EntityTypes

        this.selectMap.push({
          type,
          data: this.entities[type],
          selectedId: null
        })
      })
    }
  }
}
